import React from "react";
import PropTypes from "prop-types";
import "../../VehiculeForm.css";
import { vehiculeDataPropType } from "../../../../types/vehiculeTypes";

const DisplayLocationVehiculeNeuf = ({ vehiculeData, readOnly }) => {
  // Fonction utilitaire pour vérifier si une valeur est truthy ou égale à "1"
  const isOneOrTruthy = (value) => value === "1" || value === 1 || value === true;

  // Fonction pour vérifier si des données de location sont présentes
  const hasLocationData = () => {
    const locationFields = [
      'loc_1', 'loc_3', 'loc_4', 'loc_5', 'loc_6', 'loc_7', 'loc_8',
      'loc_9', 'loc_10', 'loc_11', 'loc_12', 'loc_13', 'loc_14', 'loc_15', 'loc_16'
    ];
    return locationFields.some(field => vehiculeData[field]);
  };

  // Détermine si le véhicule est en location basé sur loc_0 ou la présence de données
  const isVehiculeEnLocation = vehiculeData.loc_0?.toString() === "1" || hasLocationData();

  return (
    <div className="form-section">
      <div className="section">
      <h3>VÉHICULE EN LOCATION</h3>
      <div className="radio-group">
        <label>LE VÉHICULE EST-IL PRIS EN LOCATION?</label>
        <div className="radio-group-child">
          <div>
            <input
              type="radio"
              name="loc_0"
              value="1"
              checked={isVehiculeEnLocation}
              readOnly={readOnly}
            />
            <label>OUI</label>
          </div>
          <div>
            <input
              type="radio"
              name="loc_0"
              value="0"
              checked={!isVehiculeEnLocation && vehiculeData.loc_0?.toString() === "0"}
              readOnly={readOnly}
            />
            <label>NON</label>
          </div>
        </div>
      </div>
      </div>

      {isVehiculeEnLocation && (
        <>
          <div className="radio-group">
            <label>TYPE DE LOCATION:</label>
            <div className="radio-group-child">
              <div>
                <input
                  type="radio"
                  name="loc_1"
                  value="0"
                  checked={vehiculeData.loc_1?.toString() === "0"}
                  readOnly={readOnly}
                />
                <label>COURTE DURÉE</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="loc_1"
                  value="1"
                  checked={vehiculeData.loc_1?.toString() === "1"}
                  readOnly={readOnly}
                />
                <label>LONGUE DURÉE</label>
              </div>
            </div>
          </div>

          {(!vehiculeData.loc_1 || isOneOrTruthy(vehiculeData.loc_1)) && (
            <>
              <div className="form-group">
                <label>RAISON SOCIALE DE LA SOCIÉTÉ DE LOCATION, SI DIFFÉRENTE DU TITULAIRE:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_3 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>

              <div className="form-group">
                <label>N° SIRET, LE CAS ÉCHÉANT:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_4 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>
            </>
          )}

          <div className="radio-group">
            <label>LE LOCATAIRE EST:</label>
            <div className="radio-group-child">
              <div>
                <input
                  type="radio"
                  name="loc_5"
                  value="0"
                  checked={vehiculeData.loc_5?.toString() === "0"}
                  readOnly={readOnly}
                />
                <label>PERSONNE PHYSIQUE</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="loc_5"
                  value="1"
                  checked={vehiculeData.loc_5?.toString() === "1"}
                  readOnly={readOnly}
                />
                <label>PERSONNE MORALE</label>
              </div>
            </div>
          </div>

          {(!vehiculeData.loc_5 || vehiculeData.loc_5?.toString() === "0") && (
            <div className="form-group">
              <label>NOM ET PRÉNOM:</label>
              <input
                type="text"
                value={vehiculeData.loc_6 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
          )}

          {(isOneOrTruthy(vehiculeData.loc_5)) && (
            <>
              <div className="form-group">
                <label>RAISON SOCIALE:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_7 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>

              <div className="form-group">
                <label>N° SIRET:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_8 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>
            </>
          )}

          <div className="section">
            <h3>DOMICILE (si location, veuillez indiquer le domicile du locataire)</h3>
            <div className="form-group">
              <label>N° DE LA VOIE:</label>
              <input
                type="text"
                value={vehiculeData.loc_9 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>COMPLÉMENT (BIS, TER, ...):</label>
              <input
                type="text"
                value={vehiculeData.loc_10 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>TYPE DE VOIE (RUE, AVENUE...):</label>
              <input
                type="text"
                value={vehiculeData.loc_11 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>NOM DE LA VOIE:</label>
              <input
                type="text"
                value={vehiculeData.loc_12 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>CODE POSTAL:</label>
              <input
                type="text"
                value={vehiculeData.loc_13 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>COMMUNE:</label>
              <input
                type="text"
                value={vehiculeData.loc_14 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>TÉLÉPHONE PORTABLE:</label>
              <input
                type="text"
                value={vehiculeData.loc_15 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>ADRESSE MAIL:</label>
              <input
                type="text"
                value={vehiculeData.loc_16 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

DisplayLocationVehiculeNeuf.propTypes = {
  vehiculeData: vehiculeDataPropType.isRequired,
  readOnly: PropTypes.bool,
};

DisplayLocationVehiculeNeuf.defaultProps = {
  readOnly: false,
};

export default DisplayLocationVehiculeNeuf; 